import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Avatar from 'src/components/base/Avatar/Avatar';
import CustomTooltip from 'src/components/base/Tooltip/Tooltip';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { getPicture } from 'src/redux/services/commonServices';
import { getSlotIcons, stringToObject } from 'src/utils/helpers';
import { getTimeToShowForAvailabilityWidget, TimeZoneAbbreviated } from '../../utils';
import { Radio, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import AppButton from 'src/components/base/Button/Button';
import { SelfSchedulingCall } from 'src/api/questionnaire';
import { blockScheduleSlot } from 'src/redux/services/calenderServices';
import { verifyAppointment } from 'src/api/user';
import { useNavigate } from 'react-router-dom';
import { getSlotDetials } from '../../utils/AvailabilityWidgetUtils';
import { TherapistAvailabilityWidgetEnum } from '../TherapistAvailabilityWidget/TherapistAvailabilityWidgetEnum';
import { Typography } from "src/latest/src/components";


// we are using Inline styles here because it inherits styling from ModalContainer
// if we want to change this inline styling we need to change the some of the styling in the
// modal container as well and that will effect other components. That's why we are using inline styles here.

type Props = {
  item: any;
  slot: any;
  availbleSlotDetails: any;
  selectedServiceType: any;
  selectedInsuranceType: any;
  selectedAgeType: any;
};

const BookTherapistAppointment: React.FC<Props> = ({
  item,
  slot,
  availbleSlotDetails,
  selectedServiceType,
  selectedAgeType,
  selectedInsuranceType,
}) => {
  const [intake, setIntake] = useState<string>('');
  const navigate = useNavigate();
  const officeData: any =
    item?.other_data &&
    item?.other_data?.therapist_practice_address_info?.length > 0
      ? stringToObject(item.other_data.therapist_practice_address_info)
      : {};
  const [imgUri, setImgUri] = useState<string>('');
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [slotRenderDetails, setSlotRenderDetails] = useState<any>();
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    getImageUri();
  }, []);

  useEffect(() => {
    getSlotDetials(
      selectedServiceType && selectedServiceType[0],
      setSlotRenderDetails,
    );
  }, [selectedServiceType]);

  const getImageUri = async () => {
    const imageData =
      Object.entries(officeData).length !== 0 &&
      (await getPicture(officeData?.img));

    // Sets the base64 string to state
    setImgUri(imageData);
  };

  const selectedIntake = (e: any) => {
    setIntake(e.target.value);
  };

  const handleClick = () => {
    dispatch(clearModalContent());
  };

  const confirmBooking = async (
    item: any,
    slot: any,
    intake: any,
    avialbleSlotDetails: any,
    serviceType: any,
    insuranceType: any,
    ageType: any,
  ) => {
    if (buttonDisabled === false) {
      setLoadingBtn(true);

      const userId = localStorage?.getItem('therapist-user-id');

      if (!userId) {
        const data = {
          intake_type:
            TherapistAvailabilityWidgetEnum?.SELF_MATCHING_CLIENT_INTAKE,
          is_therapist_profile_page: true,
        };

        await SelfSchedulingCall(data)
          .then((res: any) => {
            if (res?.user_id) {
              setButtonDisabled(true);

              localStorage.setItem('therapist-user-id', res?.user_id);

              handleConfirmMatching(
                item,
                slot,
                res?.user_id,
                intake,
                avialbleSlotDetails,
                serviceType,
                insuranceType,
                ageType,
              );
            }
          })
          .catch((error: Error) => {
            console.error('error ', error);
          });
      } else {
        handleConfirmMatching(
          item,
          slot,
          userId && userId,
          intake,
          avialbleSlotDetails,
          serviceType,
          insuranceType,
          ageType,
        );
      }
    }
  };

  const handleConfirmMatching = async (
    item: any,
    slot: any,
    userId: string,
    intakeSelected: any,
    availableSlotDetails: any,
    serviceType: any,
    insuranceType: any,
    ageType: any,
  ) => {
    const appointmenType =
      intakeSelected === ''
        ? slot.slot.meeting_pref.includes(
            TherapistAvailabilityWidgetEnum?.Online,
          )
          ? TherapistAvailabilityWidgetEnum?.INTAKE_ONLINE
          : TherapistAvailabilityWidgetEnum?.INTAKE_IN_PERSON
        : intakeSelected;

    await blockScheduleSlot(
      {
        appointment_type: appointmenType,
        client_id: userId,
        schedule_id: availableSlotDetails?.schedule_id,
        office_address: item?.other_data?.therapist_practice_address_info,
        service_type: serviceType[0]?.unique_key,
      },
      slot.slot.hash,
    )
      .then((res: any) => {
        if (res?.http_code === 200 && userId) {
          verifyAppointment(userId)
            .then(() => {
              if (item && item?.therapist_id) {
                localStorage.setItem('widget-therapist-id', item?.therapist_id);
              }

              if (ageType[0]?.metadata && ageType[0]?.metadata?.length > 0) {
                localStorage.setItem(
                  'therapist_user_age_range',
                  ageType[0]?.metadata,
                );
              }

              if (
                insuranceType[0]?.unique_key &&
                insuranceType[0]?.unique_key?.length > 0
              ) {
                localStorage.setItem(
                  'therapist_user_insurance_key',
                  insuranceType[0]?.unique_key,
                );
              }

              setLoadingBtn(false);

              dispatch(clearModalContent());

              navigate('/therapist-user-signup', {
                state: {
                  slot,
                  item,
                  userId,
                  serviceType,
                  availableSlotDetails,
                  insuranceType,
                  ageType,
                },
              });
            })
            .catch((error: Error) => {
              setLoadingBtn(false);

              console.error(error);
            });
        }
      })
      .catch((error: Error) => {
        setLoadingBtn(false);

        console.error(error);
      });
  };

  const getMaxWidth = (selectedServiceType: any) => {
    if (!selectedServiceType || selectedServiceType.length === 0) return '100%';

    const label = selectedServiceType[0]?.label;

    switch (label) {
      case TherapistAvailabilityWidgetEnum?.Psychiatry:
        return '60%';
      case TherapistAvailabilityWidgetEnum?.Assessment:
        return '71%';
      default:
        return '100%';
    }
  };

  return (
    <div className="book-appointments-match-modal ">
      <div className="match-confirm d-flex">
        <div className="d-flex flex-row ms-auto me-auto mb-5 profile-match-score-container">
          <div className="d-flex flex-column align-items-center">
            <Avatar
              photoUrl={item.profile_picture}
              fullName={item.therapist_name}
              size="120px"
              className="mb-3"
            />
            <div
              style={{ display: 'none' }}
              className=" desktop-name-container"
            >
              <div className="d-flex" style={{ marginLeft: '5px' }}>
                <div>
                  <CustomTooltip
                    text={item.therapist_name}
                    placement="bottom"
                    className="reviewpagetip"
                  >
                    <Typography variant="size-16" weight="black">
                      {item.therapist_name.length > 21
                        ? `${item.therapist_name.substring(0, 18)}...`
                        : item.therapist_name}
                    </Typography>
                  </CustomTooltip>
                </div>
                <div style={{ marginLeft: '2px' }}>
                  <Typography>{item.therapist_pronoun}</Typography>
                </div>
              </div>
            </div>
            <div style={{ display: 'none' }} className="mobile-name-container">
              <div className="d-flex" style={{ marginLeft: '11px' }}>
                <div>
                  {' '}
                  <Typography variant="size-16" weight="black">
                    {item.therapist_name}
                  </Typography>
                </div>
                <div style={{ marginLeft: '2px' }}>
                  <Typography>{item.therapist_pronoun}</Typography>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div />
      </div>
      <div className="book-appointment__therapy-section">
        <div>
          <div
            className="d-inline-flex mb-0 justify-content-center align-items-center "
            style={{
              backgroundImage: `${slotRenderDetails?.background}`,
              height: '65px',
              width: '65px',
              borderRadius: '50%',
              margin: 'auto 4px',
              padding: '5px',
              border: ' 2.54px solid rgba(255,255,255,0.8)',
              position: 'relative',
              bottom: '33px',
              boxShadow: '0 4px 11px 0 rgba(51,177,139,0.15)',
            }}
          >
            <img
              src={slotRenderDetails?.icon}
              style={{
                maxWidth: getMaxWidth(selectedServiceType),
              }}
              alt="Therapy Icon"
            />
          </div>
          <div style={{ position: 'relative', bottom: '20px' }}>
            <Typography variant="size-16" weight="black">
              {selectedServiceType && selectedServiceType[0]?.label}
            </Typography>
          </div>
          <div className="mt-4">
            <Typography variant="size-18" weight="bold" color="color-2">
              {`${moment(slot?.slot?.slot_start_date_time).format(
                'dddd, MMMM, D • ',
              )} ${getTimeToShowForAvailabilityWidget(slot?.slot?.slot_start_date_time)}`}
              {` ${TimeZoneAbbreviated(slot?.slot?.slot_start_date_time)}`}
            </Typography>
          </div>
          <div className="d-inline-flex mt-4 mb-4">
            <span className="me-3">
              {getSlotIcons(slot.slot.meeting_pref)}
            </span>{' '}
            <Typography variant="size-18" color="color-2">
              {slot.slot.meeting_pref.replace(/<[^>]*>/g, ' ')}
            </Typography>
          </div>
          {slot.slot.tool_tip
            .replace(/<[^>]*>/g, '')
            ?.toLowerCase()
            ?.includes(
              TherapistAvailabilityWidgetEnum?.online_or_in_person,
            ) && (
            <div>
              <div className="popover-inner-content">
                <div className="mt-3 mb-3">
                  <Radio.Group
                    onChange={e => {
                      selectedIntake(e);
                    }}
                    value={intake}
                    size="large"
                  >
                    <Space direction="horizontal">
                      (
                      <>
                        <Radio
                          value={
                            TherapistAvailabilityWidgetEnum?.INTAKE_IN_PERSON
                          }
                        >
                          In-Person Meeting
                        </Radio>
                        <Radio
                          value={TherapistAvailabilityWidgetEnum?.INTAKE_ONLINE}
                        >
                          Online Meeting
                        </Radio>
                      </>
                      )
                    </Space>
                  </Radio.Group>
                </div>
              </div>
            </div>
          )}
          {((slot.slot.tool_tip
            .replace(/<[^>]*>/g, '')
            ?.toLowerCase()
            ?.includes('person') &&
            !slot.slot.tool_tip
              .replace(/<[^>]*>/g, '')
              ?.toLowerCase()
              ?.includes('online or in person')) ||
            (slot.slot.tool_tip
              ?.replace(/<[^>]*>/g, '')
              ?.toLowerCase()
              ?.includes(
                TherapistAvailabilityWidgetEnum?.online_or_in_person,
              ) &&
              intake ===
                TherapistAvailabilityWidgetEnum?.INTAKE_IN_PERSON)) && (
            <div
              className="office-location"
              style={{
                height: '178px',
                width: '299px',
                borderRadius: '10px',
                backgroundColor: '#FFFFFF',
                boxShadow: '0 22px 44px 0 rgba(0, 0, 0, 0.06)',
                margin: '30px auto',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="size-14"
                weight="bold"
                color="color-28"
                className=" mt-2 mb-3"
              >
                {' '}
                THERAPIST'S IN-PERSON OFFICE
              </Typography>
              <div className="d-flex flex-row mt-4">
                {Object.entries(officeData).length > 0 && (
                  <div className="d-flex align-items-center ms-5 me-1">
                    <Avatar
                      photoUrl={imgUri}
                      fullName={item?.therapy_location[0]}
                      size="76px"
                      className="mb-1"
                    />
                  </div>
                )}
                <div
                  className="d-flex align-items-center m-auto flex-column"
                  style={{ width: '40%' }}
                >
                  <Typography variant="size-14" weight="bold">
                    {item.therapy_location}
                  </Typography>
                  <Typography variant="size-14" className="mt-2">
                    {Object?.entries(officeData)?.length > 0 &&
                      officeData?.addressInfo1.replace(/<[^>]*>/g, '') +
                        ' ' +
                        officeData?.addressInfo2.replace(/<[^>]*>/g, '') +
                        ' ' +
                        officeData?.addressInfo3.replace(/<[^>]*>/g, '')}
                  </Typography>
                </div>
              </div>
              {Object.entries(officeData).length === 0 && (
                <Typography variant="size-14" className="m-4">
                  Office address not available. Please call for more
                  information: 512-469-0889
                </Typography>
              )}
            </div>
          )}

          <br />
          <AppButton
            label={'Continue'}
            isProcessing={loadingBtn}
            className="Booking-continue-button"
            onClick={() => {
              confirmBooking(
                item,
                slot,
                intake,
                availbleSlotDetails,
                selectedServiceType,
                selectedInsuranceType,
                selectedAgeType,
              );
            }}
            disabled={
              (slot.slot.tool_tip
                ?.replace(/<[^>]*>/g, '')
                .toLowerCase()
                ?.includes(
                  TherapistAvailabilityWidgetEnum?.online_or_in_person,
                ) &&
                intake === '') ||
              buttonDisabled
            }
          />
        </div>
        <div className="review-back-button">
          <FontAwesomeIcon
            icon={faArrowLeftLong}
            className="review-arrow-left ms-2 mt-1"
            size="sm"
          />
          <button
            onClick={handleClick}
            className=" ChooseBack btn btn-transparent"
          >
            Choose a different Appointment
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookTherapistAppointment;
